<template>
  <div>
    <h3 class="mb-0">
      <span class="d-inline-block mt-1">
        <span class="d-block">{{meta.name}}</span>
      </span>
      <b-button
        size="sm"
        variant="outline-primary"
        class="pull-right"
        @click="() => $emit('toggle-picker')">
        <span v-if="showPicker">
          <i class="fa fa-undo mr-2"></i>
          Close picker
        </span>
        <span v-else>
          <i class="fa fa-pencil mr-2"></i>
          Pick different file
        </span>
      </b-button>
    </h3>
    <h3 class="small mb-4" style="font-size: 13px;" v-if="file">
      <span>{{file.originalName}}</span> |
      <span>{{file.rowCount | formatInt}} rows</span> |
      <span>Created {{file.createdAt | humanize}}</span>
    </h3>
  </div>
</template>

<script>
  export default {
    name: 'SourceHeader',

    props: {
      showPicker: Boolean,
      meta: Object
    },

    computed: {
      file() {
        const {type} = this.meta;
        return this.$store.getters.getActiveFile(type);
      }
    },
  };
</script>

<style scoped>

</style>
